import { render } from "./LitigationSearchMetadataInput.vue?vue&type=template&id=1bdbbe62&scoped=true"
import script from "./LitigationSearchMetadataInput.vue?vue&type=script&lang=js"
export * from "./LitigationSearchMetadataInput.vue?vue&type=script&lang=js"

import "./LitigationSearchMetadataInput.vue?vue&type=style&index=0&id=1bdbbe62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdbbe62"]])

export default __exports__